import { performRequest, performRequestFourth, performRequestSecond, performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';
import Cookies from 'universal-cookie';
const cookie = new Cookies();

export const createLead = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  return performRequest(apiEndPoints.methodType.POST, `${apiEndPoints.createLead}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

export const viewLeadDetailsModified = (pk = '', sk = '', lead_id = '') => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.viewLeadDetails}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${sk ? `&lead_sk=${sk}` : ''}${
      lead_id ? `&lead_id=${lead_id}` : ''
    }`
  );
};

export const getLeads = (data = false, assigned_to = false, keyword = false, limit = 1000) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  let assignedTo = assigned_to ? assigned_to.replaceAll('#', '%23') : '';
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.listLeads}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${assigned_to ? `&assigned_to=${assignedTo}` : ''}${
      keyword ? `&keyword=${keyword}` : ''
    }&limit=${limit}`,
    data
  );
};

export const updateLeadDetails = (lead_sk, data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  let leadSK = lead_sk ? lead_sk.replaceAll('#', '%23') : '';
  return performRequest(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateLeadDetails}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&lead_sk=${leadSK}`,
    data
  );
};

export const deleteLead = (lead_sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  let leadSK = lead_sk ? lead_sk.replaceAll('#', '%23') : '';
  return performRequest(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteLead}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&lead_sk=${leadSK}`
  );
};

export const closeLead = (lead_sk, data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  let leadSK = lead_sk ? lead_sk.replaceAll('#', '%23') : '';
  return performRequest(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.closeLead}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&lead_sk=${leadSK}`,
    data
  );
};

export const getLeadDescription = (lead_id, isDraft) => {
  const tenantId = cookie.get('tenantId') || null;
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.getLeadDescription}?tenant_id=${tenantId}&lead_id=${lead_id}${isDraft ? `&is_draft=${isDraft}` : ''}`,
    null,
    null,
    true,
    true
  );
};

export const convertToCase = (lead_sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  let leadSK = lead_sk ? lead_sk.replaceAll('#', '%23') : '';
  return performRequest(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.convertToCase}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&lead_sk=${leadSK}`
  );
};

export const saveLeadCloseReason = (leadSk, data, is_lead) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.leadCloseReason}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&lead_sk=${leadSk}&is_lead=${is_lead}`,
    data
  );
};

export const viewLeadClosureReasons = (
  is_lead,
  excludeFromLoading = false,
  sort_order = 'alphabet_ascending',
  limit = 10,
  token = '',
  direction = 'forward',
  practice_area_id = '',
  search_key = ''
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.leadClosureReasons}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&is_lead=${is_lead}&sort_order=${sort_order}&limit=${limit}&pagination_direction=${direction}`;
  if (token) {
    url += `&pagination_token=${token}`;
  }
  if (practice_area_id) {
    url += `&practice_area_id=${practice_area_id}`;
  }
  if (search_key) {
    url += `&search_key=${search_key}`;
  }
  return performRequestSecond(apiEndPoints.methodType.GET, url, null, '', true, excludeFromLoading);
};

/**
 * Paginated closure reasons (v2). Case close reasons: `is_lead: false`.
 *
 * @param {Object} opts
 * @param {boolean} [opts.is_lead=false]
 * @param {boolean} [opts.excludeFromLoading=false]
 * @param {number} [opts.limit=20]
 * @param {number} [opts.page=1]
 * @param {string} [opts.sort_by='']
 * @param {string} [opts.sort_order='']
 * @param {string} [opts.keyword='']
 * @param {string} [opts.practice_area_id='']
 */
export const listClosureReasonsV2 = ({
  is_lead = false,
  excludeFromLoading = false,
  limit = 20,
  page = 1,
  sort_by = '',
  sort_order = '',
  keyword = '',
  practice_area_id = '',
} = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${
    apiEndPoints.listClosureReasonsV2
  }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&is_lead=${is_lead}&limit=${limit}&page=${page}&sort_by=${encodeURIComponent(
    sort_by
  )}&sort_order=${encodeURIComponent(sort_order)}`;
  if (keyword) {
    url += `&keyword=${encodeURIComponent(keyword)}`;
  }
  if (practice_area_id) {
    url += `&practice_area_id=${encodeURIComponent(practice_area_id)}`;
  }
  return performRequestFourth(apiEndPoints.methodType.GET, url, null, '', true, excludeFromLoading);
};

export const listLeadReferrals = (is_referral_entity = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listLeadReferrals}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${
      is_referral_entity ? `&is_referral_entity=${is_referral_entity}` : ''
    }`
  );
};

export const createLeadReferral = (is_lead, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createLeadReferral}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&is_lead=${is_lead}`,
    data
  );
};

export const updateLeadUser = (leadId, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let lead_id = leadId ? leadId.replaceAll('#', '%23') : '';
  return performRequest(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateLeadUser}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&lead_id=${lead_id}`,
    data
  );
};

export const createLeadSource = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createLeadSource}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const listLeadSource = (limit = 10, pagination_token = '', pagination_direction = 'forward', inputValue = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${
      apiEndPoints.listLeadSources
    }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${limit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}${
      inputValue ? `&keyword=${inputValue}` : ''
    }`
  );
};

export const viewReferredOutReasons = (
  limit = 10,
  pagination_token = '',
  pagination_direction = 'forward',
  sort_order = 'alphabet_ascending',
  practice_area_id = ''
) => {
  const [tenantId, tenantSk] = getTenantDetails();

  return performRequestSecond(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listReferredOutReasons}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${limit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&sort_order=${sort_order}&practice_area_id=${practice_area_id}`
  );
};

export const createReferredOutReason = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createReferredOutReason}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const updateReferredOutReason = (referred_out_reason_sk, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateReferredOutReason}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&referred_out_reason_sk=${referred_out_reason_sk}`,
    data
  );
};

export const getLeadClosureReasons = (
  lead_sk,
  is_lead,
  limit = 10,
  pagination_token = '',
  pagination_direction = 'forward',
  sort_order = 'alphabet_ascending'
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.leadClosureReasons}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&is_lead=${is_lead}&limit=${limit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&sort_order=${sort_order}`
  );
};
